export const tableHeaders = {
    consigneeCode: 'Consignee Code',
    consigneeName: 'Consignee Name',
    city: 'City',
    address: 'Consignee Address',
    createdBy: 'Created By',
    createdOn: 'Created On',
    updatedBy: 'Updated By',
    updatedOn: 'Updated On',
    actions: 'Edit/Delete'
}